/**
 * Toast queue.
 *
 * plugins/augurly ships a single-instance Toast with no queue, so a second
 * notification replaces the first. This is the augurly_admin form: a store plus
 * a container that renders a stack.
 */

let nextId = 1;

export const toastState = $state({ items: [] });

function push(type, message, duration = 5000) {
  const id = nextId++;
  toastState.items = [...toastState.items, { id, type, message, duration }];
  return id;
}

export const toast = {
  success: (m, d) => push('success', m, d),
  error: (m, d) => push('error', m, d ?? 8000),
  warning: (m, d) => push('warning', m, d),
  info: (m, d) => push('info', m, d),
  dismiss(id) {
    toastState.items = toastState.items.filter((t) => t.id !== id);
  },
  clear() {
    toastState.items = [];
  },
};
